<div class="schedule-program" [class.overlayed]="showEpisodeOptions" [class.readonly]="readOnly"
  (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" (mouseout)="onMouseOut()">
  <div class="schedule-program__text-wrapper">
    <div class="schedule-program__title">
      {{ program.name }}
    </div>
    <div class="schedule-program__episode-title">
      {{ program.program.options?.episode?.title }}
    </div>
    <div class="schedule-program__range">
      {{ program.formatted.range }}
    </div>
  </div>
  <div (mouseenter)="onMouseEnterOverlay()" (mouseleave)="onMouseLeaveOverlay()" class="schedule-program__overlay"
    *ngIf="showEpisodeOptions">
    <button (click)="onEdit.emit(program)" class="schedule-program__overlay__button">
      <mat-icon>{{ readOnly ? "visibility" : "edit" }}</mat-icon>
      <span>Edit</span>
    </button>
    <div class="info-icon-container" [matTooltip]="getTooltipText()" matTooltipClass="schedule-program__tooltip"
      matTooltipPosition="after">
      <mat-icon>info</mat-icon>
    </div>
  </div>
</div>